import './gift-texts.scss'
import VideoFrame from "./video-frame";

const welcome = (content) => {
    return (
        <div>
            <h1 className='title'>
                {content?.title || <>THE OPEN FUTURE <br/>
                    OF PRIVATE AVIATION</>}
            </h1>
            <h2 className='sub-title'>
                {content?.sub_title}
            </h2>
            <div className='body-text' dangerouslySetInnerHTML={{__html: content.text}}/>
            {!content.video_link ? null : <VideoFrame src={content.video_link} title={content.video_title} />}
        </div>
    )
}
const login = (content) => {
  return (
    <div>
      <h1 className='title'>
        {content?.title || <>THE OPEN FUTURE <br/>
          OF PRIVATE AVIATION</>}
      </h1>
      <h2 className='sub-title'>
        {content?.sub_title}
      </h2>
      <div className='body-text' dangerouslySetInnerHTML={{__html: content.text}}/>
      {!content.video_link ? null : <VideoFrame src={content.video_link} title={content.video_title} />}
    </div>
  )
}

const done = (content) => {
  if (content?.redirect_after) {
    setTimeout(() =>  window.location.href = content?.redirect_url ? content.redirect_url : 'https://flyxo.com', 10000)
  }
  return <div className='success_message' dangerouslySetInnerHTML={{__html: content.success_message}} />
}

export const strapiContent = {
    welcome,
    login,
    done,
}
